"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("@insided/shared/uikit/Editor/Attachments/utils");

var _Editor = _interopRequireDefault(require("@insided/shared/uikit/Editor"));

var _redirect = _interopRequireDefault(require("@insided/deprecated-utils/redirect"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _spamService = require("@insided/shared/services/spamService");

var _topicService = require("@insided/shared/services/topicService");

var _attachmentService = require("@insided/deprecated-services/attachmentService");

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function determineRequest(_ref) {
  var replyId = _ref.replyId,
      topicId = _ref.topicId,
      type = _ref.type;
  if (replyId !== null) return (0, _topicService.editPost)(topicId, replyId, type);
  return (0, _topicService.newPost)(topicId, type);
}

function checkIsSpam(_x, _x2, _x3) {
  return _checkIsSpam.apply(this, arguments);
}

function _checkIsSpam() {
  _checkIsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(replyId, type, isReply) {
    var _response2;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _spamService.isSpam)(replyId, type, isReply);

          case 3:
            _response2 = _context3.sent;
            return _context3.abrupt("return", _response2.data.result.isSpam);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            _context3.next = 11;
            return new Promise(function (resolve) {
              resolve(false);
            });

          case 11:
            return _context3.abrupt("return", _context3.sent);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _checkIsSpam.apply(this, arguments);
}

function getReplyIdFromResponse(response) {
  var _response$headers$loc;

  var location = (_response$headers$loc = response.headers.location) !== null && _response$headers$loc !== void 0 ? _response$headers$loc : '';
  var match = /replies\/(\d+)/.exec(location);
  return match ? Number(match[1]) : null;
}

var PostEditorV2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PostEditorV2, _Component);

  var _super = _createSuper(PostEditorV2);

  function PostEditorV2() {
    var _this$props$attachmen, _this$props;

    var _this;

    (0, _classCallCheck2.default)(this, PostEditorV2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      attachments: (_this$props$attachmen = (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.attachments) !== null && _this$props$attachmen !== void 0 ? _this$props$attachmen : [],
      errors: [],
      isLoading: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(content, attachments, hasFileInProgress) {
        var props, submitRequest, _props$replyId, _response, errors, newErrors, replyId, contentType, _isSpam, isPending, errorMessage, _response$data$succes, _error$response$data, _error$response$data$, _error$response$data2, _error$response$data3, _error$response$data4, _errorMessage;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                props = _this.props;
                submitRequest = determineRequest(props);

                _this.setState({
                  isLoading: true
                });

                _context.prev = 3;
                _context.next = 6;
                return submitRequest(content, attachments, hasFileInProgress);

              case 6:
                _response = _context.sent;
                errors = _response.data.errors;

                if (!(errors !== null && errors !== void 0 && errors.length)) {
                  _context.next = 12;
                  break;
                }

                newErrors = errors.map(function (error) {
                  return {
                    errorMessage: error
                  };
                });

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat(newErrors),
                    isLoading: false
                  };
                });

                return _context.abrupt("return");

              case 12:
                replyId = (_props$replyId = props.replyId) !== null && _props$replyId !== void 0 ? _props$replyId : getReplyIdFromResponse(_response); // const publicReplyId = props.publicReplyId as string

                if (!replyId) {
                  _context.next = 27;
                  break;
                }

                contentType = props.type === 'conversation' ? 'reply' : props.type + '_reply';
                (0, _utils.checkAttachments)(hasFileInProgress);
                _context.next = 18;
                return (0, _attachmentService.saveAttachmentsToTopic)(String(replyId), contentType, attachments);

              case 18:
                // Attachments are now part of the reply object, no need to fetch them
                _this.setState({
                  attachments: attachments
                });

                _context.next = 21;
                return checkIsSpam(replyId, props.type, true);

              case 21:
                _isSpam = _context.sent;
                // is-pending header is 1 if reply is pending, 0 if not pending
                isPending = Boolean(Number(_response.headers['is-pending']));

                if (!(_isSpam || isPending)) {
                  _context.next = 27;
                  break;
                }

                errorMessage = (0, _preact.h)(_phrase.default, {
                  m: "Forum",
                  p: "spam_moderation.reviewbymoderator.message"
                });

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: errorMessage
                    }),
                    isLoading: false
                  };
                });

                return _context.abrupt("return");

              case 27:
                if (!props.redirect) {
                  _context.next = 29;
                  break;
                }

                return _context.abrupt("return", (0, _redirect.default)((_response$data$succes = _response.data.success) !== null && _response$data$succes !== void 0 ? _response$data$succes : _response.headers.location));

              case 29:
                // Convert attachments to the expected format for the callback
                props.onSuccess(content, attachments, _response);

                _this.setState({
                  errors: []
                });

                window.CKEDITOR.instances.editor1.setData('');
                _context.next = 38;
                break;

              case 34:
                _context.prev = 34;
                _context.t0 = _context["catch"](3);
                _errorMessage = ((_error$response$data = _context.t0.response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.errors) === null || _error$response$data$ === void 0 ? void 0 : _error$response$data$.pagetext) || ((_error$response$data2 = _context.t0.response.data) === null || _error$response$data2 === void 0 ? void 0 : (_error$response$data3 = _error$response$data2.errors) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.content) || ((_error$response$data4 = _context.t0.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.errors) || "Something's gone wrong";

                _this.setState(function (prevState) {
                  return {
                    errors: prevState.errors.concat({
                      errorMessage: _errorMessage
                    })
                  };
                });

              case 38:
                _this.setState({
                  isLoading: false
                });

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 34]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content, attachments) {
      _this.setState({
        attachments: attachments
      });
    });
    return _this;
  }

  (0, _createClass2.default)(PostEditorV2, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      return (0, _preact.h)("div", null, (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref3) {
        var lock = _ref3.lock;
        return (0, _preact.h)(_Editor.default, (0, _extends2.default)({}, props, {
          disableFileAttachments: props.disableFileAttachments,
          isControl: props.isControl,
          autoFocus: !!props.autoFocus,
          errors: _this2.state.errors,
          isLoading: _this2.state.isLoading,
          onSubmit: /*#__PURE__*/function () {
            var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(content, attachments, hasFileInProgress) {
              return _regenerator.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this2.handleSubmit(content, attachments, hasFileInProgress);

                    case 2:
                      return _context2.abrupt("return", _context2.sent);

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x7, _x8, _x9) {
              return _ref4.apply(this, arguments);
            };
          }(),
          attachments: _this2.state.attachments,
          onChange: function onChange(content, attachments) {
            _this2.onChange(content, attachments);

            lock(content, props.data);
          }
        }));
      }));
    }
  }]);
  return PostEditorV2;
}(_preact.Component);

var _default = PostEditorV2;
exports.default = _default;